import axios from 'axios';
import type {
  IGetAnsweringServicePayerAndTypeRequest,
  IGetAnsweringServicePayerAndTypeResponse,
} from '@/app-package';

const getAnsweringServicePayerAndType =
  async (): Promise<IGetAnsweringServicePayerAndTypeResponse> => {
    const config: IGetAnsweringServicePayerAndTypeRequest = {
      url: `/answering_service/payer_and_type`,
      method: 'get',
    };

    const { data } =
      await axios.request<IGetAnsweringServicePayerAndTypeResponse>(config);
    return data;
  };

export default getAnsweringServicePayerAndType;
